import {
  useState,
  useRef,
  forwardRef,
  useEffect,
  useImperativeHandle,
} from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Paper, Stack } from "@mui/material";
import { InputPercentageSpouse } from "../Components/Inputs/Input_Percentage.jsx";
import { InputMoney } from "../Components/Inputs/Input_Money.jsx";
import { InputYear } from "../Components/Inputs/Input_Year.jsx";
import { InputAge } from "../Components/Inputs/Input_Age.jsx";

const defData = {
  method: "",
  edited: false,
  value_initial: 0,
  up_to_age: 0,
  percent_spousal: 0,
  actual: false,
  additional: false,
  inflate: false,
  inflate_base_year: new Date().getFullYear() - 1,
  inflate_threshold: 0,
};

const GetDataFromString = (v) => {
  if (v === undefined || v === null) {
    return defData;
  }
  let s = v.split(";");
  if (s.length > 1) {
    return JSON.parse(s[1]);
  }
  return defData;
};

const GetValueFromString = (v) => {
  if (v === undefined || v === null) {
    return "";
  }
  let s = v.split(";");
  if (s.length > 0) {
    return s[0];
  }
  return "";
};

const GetEmptyFromString = (v) => {
  if (v === undefined || v === null) {
    return true;
  }
  let s = v.split(";");
  if (s.length > 1) {
    let j = JSON.parse(s[1]);
    if (j.method === "UserInput") {
      return false;
    }
  }
  return true;
};

export const MoneyInflateEditor = forwardRef((props, ref) => {
  const refInput = useRef(null);
  const [valueString, setValueString] = useState(props.value);
  const [modified, setModified] = useState(false);
  const [formData, setFormData] = useState(GetDataFromString(props.value));

  useEffect(() => {
    // focus on the input
    //refInput.current.focus();
  }, []);

  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, () => {
    return {
      // the final value to send to the grid, on completion of editing
      getValue() {
        console.log(valueString);
        if (modified) {
          let ns = formData.value_initial + ";" + JSON.stringify(formData);
          console.log(ns);
          return ns;
        }

        // this simple editor doubles any value entered into the input
        return valueString;
      },

      // Gets called once before editing starts, to give editor a chance to
      // cancel the editing before it even starts.
      isCancelBeforeStart() {
        return false;
      },

      // Gets called once when editing is finished (eg if Enter is pressed).
      // If you return true, then the result of the edit will be ignored.
      isCancelAfterEnd() {
        // our editor will reject any value greater than 1000
        return false;
      },
    };
  });

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
      ["method"]: "UserEdited",
    });
    setModified(true);
  };

  const onChange_c = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked,
      ["method"]: "UserEdited",
    });
    setModified(true);
  };
  console.log(props);
  return (
    //<form className="container my-3 mx-2">
    <Paper elevation={2} sx={{ p: 4 }}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2}>
          <InputMoney
            money={formData.value_initial}
            name="value_initial"
            onChange={onChange}
          //ref={refInput}
          />
          <Stack>
            <Form.Check
              label="Actual"
              name="actual"
              checked={formData.actual}
              onChange={onChange_c}
              disabled={Number(formData.value_initial) === 0}
            />
            {props.colDef.type !== undefined &&
              props.colDef.type.includes("additional") && (
                <Form.Check
                  label="Additional"
                  name="additional"
                  checked={formData.additional}
                  onChange={onChange_c}
                  disabled={Number(formData.value_initial) === 0}
                />
              )}
          </Stack>
        </Stack>
        {props.colDef.type !== undefined &&
          props.colDef.type.includes("spousePercentage") && (
            <InputPercentageSpouse
              percent={formData.percent_spousal}
              name="percent_spousal"
              onChange={onChange}
              disabled={Number(formData.value_initial) === 0}
            />
          )}
        {props.colDef.type !== undefined &&
          props.colDef.type.includes("uptoage") && (
            <InputAge
              name="up_to_age"
              min={0}
              age={formData.up_to_age}
              onChange={onChange}
              disabled={Number(formData.value_initial) === 0}
            />
          )}
        {props.colDef.type !== undefined &&
          props.colDef.type.includes("inflatable") && (
            <Stack direction="row" spacing={2}>
              <Form.Label>
                {"Inflate"}
                <InputGroup.Checkbox
                  // aria-label="Checkbox for following text input"
                  label="Inflate"
                  name="inflate"
                  onChange={onChange_c}
                  checked={formData.inflate}
                  disabled={Number(formData.value_initial) === 0}
                />
              </Form.Label>
              <InputYear
                label="Base Year"
                name="inflate_base_year"
                year={formData.inflate_base_year}
                onChange={onChange}
                disabled={
                  !(Number(formData.value_initial) !== 0 && formData.inflate)
                }
              />

              <InputMoney
                xlabel="Threshold"
                name="inflate_threshold"
                money={formData.inflate_threshold}
                xname="Threshold"
                max={10000}
                //sx={{ width: 80 }}
                onChange={onChange}
                disabled={
                  !(Number(formData.value_initial) !== 0 && formData.inflate)
                }
              />
            </Stack>
          )}
      </Stack>
    </Paper>
    // </form>
  );
});

export const MoneyInvestEditor = forwardRef((props, ref) => {
  const refInput = useRef(null);
  const [valueString, setValueString] = useState(props.value);
  const [modified, setModified] = useState(false);
  const [formData, setFormData] = useState(GetDataFromString(props.value));

  useEffect(() => {
    // focus on the input
    //refInput.current.focus();
  }, []);

  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, () => {
    return {
      // the final value to send to the grid, on completion of editing
      getValue() {
        console.log(valueString);
        if (modified) {
          let ns = formData.value_initial + ";" + JSON.stringify(formData);
          console.log(ns);
          return ns;
        }

        // this simple editor doubles any value entered into the input
        return valueString;
      },

      // Gets called once before editing starts, to give editor a chance to
      // cancel the editing before it even starts.
      isCancelBeforeStart() {
        return false;
      },

      // Gets called once when editing is finished (eg if Enter is pressed).
      // If you return true, then the result of the edit will be ignored.
      isCancelAfterEnd() {
        // our editor will reject any value greater than 1000
        return false;
      },
    };
  });

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
      ["method"]: "UserEdited",
    });
    setModified(true);
  };

  const onChange_c = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked,
      ["method"]: "UserEdited",
    });
    setModified(true);
  };

  return (
    <form className="container my-3 mx-2">
      <Stack spacing={2}>
        <Stack direction="row" spacing={2}>
          <InputMoney
            money={formData.value_initial}
            name="value_initial"
            onChange={onChange}
          //ref={refInput}
          />
          <Stack>
            <Form.Check
              label="Actual"
              name="actual"
              checked={formData.actual}
              onChange={onChange_c}
              disabled={Number(formData.value_initial) === 0}
            />
          </Stack>
        </Stack>
      </Stack>
    </form>
  );
});
